import * as React from 'react';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {ModuleModel} from '../../model/ModuleModel';
import {IUserModelProps, UserModel} from '../../model/UserModel';
import {getAllModules} from '../../services/moduleService';
import {getUserDetails, updateUser} from '../../services/userService';
import {dispatch, isFormEmpty, userUniqueID} from '../../utils/generalUtils';
import {Async} from '../reusableComponents/Async';
import {BasePage} from '../reusableComponents/BasePage';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {FileInputButton} from '../reusableComponents/FormComponents/FileInputButton';
import {Loader} from '../reusableComponents/Loader/Loader';
import {UserForm} from './UserForm';
import {getAllOrg} from '../../services/organizationService';
import {getUserData} from '../../services/utilityServices';
import {OrgModel} from '../../model/OrgModel';
import {setLoading, setSuccess} from '../../actions/loadingActions';

export interface IUpdateUserProps {
    history: IHistory;
    userInstance: UserModel;
    currentUserInstance: UserModel;
    organizationInstances: OrgModel;
    moduleInstances: ModuleModel[];
    userUID: string;
    userImageBase64: string;
    userSignBase64: string;
    adminId: string;
}

export class UpdateUserImpl extends React.PureComponent<IUpdateUserProps, {}> {

    loggedInUser = getUserData();

    constructor(props: IUpdateUserProps) {
        super(props);
    }

    public refs: {
        file: FileInputButton;
        userData: UserForm;
    };

    public promise = async () => {
        await getUserDetails(this.props.userUID);
        if (this.loggedInUser.accessLevel === 'L1') {
            getAllOrg();
        } else if (this.loggedInUser.accessLevel === 'L2') {
            await getAllModules();
        }
    }

    public handleSubmit = async (values) => {
        const ignoreList = [];
        if (values.accessLevel && (values.accessLevel === 'L1')) {
            ignoreList.push('organization');
        }
        if (isFormEmpty(values, ignoreList)) {
            return;
        }
        setLoading('UpdateUser');
        return await updateUser(values, null, this.refs.userData.profilePic,
            this.refs.userData.signature, this.props.history, this.props.userUID);
    }

    public render() {
        const isL3User = UserModel.isTrainee(this.props.currentUserInstance);
        return <BasePage title="Update User" icon="user-edit">
            <Async
                identifier="UpdateUser"
                promise={this.promise}
                loader={<Loader type="async"/>}
                content={
                    <UserForm
                        isL3User={isL3User}
                        loadDefaultValues={() =>
                            dispatch(actions.change('forms.updateUserForm.adminId', this.props.adminId))}
                        moduleInstances={this.props.moduleInstances}
                        id="UpdateUser"
                        ref="userData"
                        loggedInUser={this.loggedInUser}
                        singImage={this.props.userSignBase64}
                        orgsList={this.props.organizationInstances}
                        instance={this.props.userInstance}
                        userImage={this.props.userImageBase64}
                        model="forms.updateUserForm"
                        onSubmit={this.handleSubmit}
                    />}
                error={<ErrorPage/>}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    const moduleInstances = ModuleModel.list();
    const organizationInstances = OrgModel.list();
    return {
        moduleInstances, adminId: userUniqueID(state),
        userInstance: UserModel.get(ownProps.match.params.id),
        currentUserInstance: UserModel.getCurrentUserInstance(),
        userUID: ownProps.match.params.id,
        organizationInstances,
        userImageBase64: state.miscellaneous.get('userImageBase64'),
        userSignBase64: state.miscellaneous.get('userSignBase64')
    };
}

export const UpdateUser = withRouter(connect<{}, {}, IUpdateUserProps>(mapStateToProps)(UpdateUserImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/UpdateUser.tsx